export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'reports.delete_specialmessage',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:reports:specialmessage:export',
    },
  },
}